import { Component, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatDialogRef } from '@angular/material/dialog';
import { Inject } from '@angular/core';

@Component({
  selector: 'app-product-photo-modal',
  templateUrl: './product-photo-modal.component.html',
  styleUrls: ['./product-photo-modal.component.sass']
})
export class ProductPhotoModalComponent implements OnInit {

  constructor(
    private selfRef: MatDialogRef<ProductPhotoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  closePhotoModal() {
    this.selfRef.close()
  }

}
